<template>
    <a-entity ref="restart" @loaded="update">
      <a-plane
        v-for="l in langs"
        rotation="-90 0 0"
        class="Fuse"
        width=".15"
        :ref="'btn_' + l"
        :key="l"
        height=".15"
        @click="reset(l)"
        @loaded="setDyniquePos('btn_' + l)"
        material="shader: flat; depthTest: false"
        @materialtextureloaded="checkShow"
        scale="0 0 0"
        transparent="true"
        :src="cdn(require('./img/restart-' + l + '.png'))"
      >
        <a-circle
          color="#000"
          radius=".1"
          segments="32"
          opacity=".7"
          transparent="true"
          position="0 0 -.001"
          material="shader: flat; depthTest: false"
        />
      </a-plane>
    </a-entity>
</template>

<script>
export default {
  name: 'BottomVr',
  data: () => ({
    langs: ['fr', 'en'],
    checkPos: [
      {
        ref: 'btn_fr',
        desktop: { x: -.16, y: -1.3, z: -.21 },
      },
      {
        ref: 'btn_en',
        desktop: { x: .16, y: -1.3, z: -.21 },
      }
    ]
  }),
  beforeDestroy() {
    if(this.$rafId)
      cancelAnimationFrame(this.$rafId)
  },
  watch: {
    '$route': 'checkShow'
  },
  methods: {
    checkShow() {
      const routeName = this.$route.meta.name
      const dontShowOn = ['load', 'lock', 'infos', 'vrstart']
      const scaleTo = dontShowOn.indexOf(routeName) > -1 ? 0 : 1.5

      TweenLite.to([this.$refs.btn_en, this.$refs.btn_fr], 1, { aframe: { scale: scaleTo } })
    },
    reset(lang) {
      this.$store.commit('app/RESET', lang)
      this.vr
      ? this.$router.push({ name: 'vrstart.' + lang })
      : this.$router.push({ name: 'load.' + lang })
    },
    update() {
      this.$rafId = requestAnimationFrame(this.update)
      const rotCameraY = this.$parent.$refs.camera.object3D.rotation.y
      const rotBtnY = this.$refs.restart.object3D.rotation.y
      const diff = Math.abs(rotCameraY - rotBtnY)

      if(this.vr) {
        this.$parent.$refs.vr_fix.object3D.position.y = -this.$parent.$refs.camera.object3D.position.y
        this.$parent.$refs.vr_fix.object3D.position.z = -this.$parent.$refs.camera.object3D.position.z
        this.$parent.$refs.vr_fix.object3D.position.x = -this.$parent.$refs.camera.object3D.position.x
        // this.$refs.restart.object3D.position.x = this.$parent.$refs.camera.object3D.position.x
        // this.$refs.restart.object3D.position.z = this.$parent.$refs.camera.object3D.position.z
      }

      if(diff > 1.8)
        // TweenLite.to(this.$refs.restart, .5, { aframe: { rotationY: THREE.Math.radToDeg(rotCameraY)  } })
        TweenMax.to(this.$refs.restart.object3D.rotation, .5, {
          directionalRotation: { y: rotCameraY + '_short'}, useRadians: true
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bottom-vr/BottomVr.vue